/**
 * Traducción de los códigos de error del backend de staff (TASK-20/21).
 *
 * El envelope uniforme es `{ code, message, detail, field_errors }`
 * (grade_card/utils/exceptions.py). El `message` del backend ya viene en
 * español, pero los 409 anti-bloqueo merecen un texto propio porque son los
 * únicos que el operador puede resolver cambiando lo que hace.
 */
const STAFF_ERROR_MESSAGES = {
  staff_self_deactivation: "No puedes desactivar tu propia cuenta de staff.",
  staff_last_platform_admin:
    "No puedes dejar la plataforma sin ningún administrador activo. Asigna el rol a otra persona antes de continuar.",
  staff_permission_denied: "Tu rol no permite esta acción.",
  password_change_required:
    "Debes cambiar tu contraseña temporal antes de operar en el panel.",
};

/** Mensaje presentable para un error de axios contra `superadmin/staff/`. */
function staffApiError(err, fallback = "No se pudo completar la operación.") {
  const data = err?.response?.data ?? {};
  return STAFF_ERROR_MESSAGES[data.code] ?? data.message ?? data.detail ?? fallback;
}

/** Errores por campo (`{ email: ["..."] }`) para pintarlos junto al input. */
function fieldErrors(err) {
  const fe = err?.response?.data?.field_errors;
  return fe && Object.keys(fe).length > 0 ? fe : null;
}

/** Primer mensaje de un campo concreto, o null. */
function fieldError(err, field) {
  const value = fieldErrors(err)?.[field];
  if (!value) return null;
  return Array.isArray(value) ? value[0] : String(value);
}

export { STAFF_ERROR_MESSAGES, staffApiError, fieldErrors, fieldError };
